<template>
  <div class="landmarkView">	
	
	<div>
		<el-carousel loop indicator-position="none" arrow="never"
		 @change="changetab" height="1080px" ref="img" >
			<el-carousel-item v-for="(item,index) in list" :key="index">
				<el-image
				  class="imgcenter"
				  @click="nav(item.link)"
				  :src="getFileAccessHttpUrl(item.fileId)"
				  alt=""
				  fit='cover'
				></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
	
	<div class="realtime_donate">
	  <div class="donatecon">
			
		<div class="con" @mouseover="mouseOver()" @mouseleave="mouseLeave()">
			<div class="l_a">
				实时捐助
			</div>
			<div class="l_b">
				<div class="line"></div>
			</div>
			
			<div class="l_c" >
				<div v-for="(item,index) in donationList" class="l_con"
				:style="{transform:'translateY(-'+move*100+'px)'}">
					<span class="namecon">
						<span>
							{{item.donationUserId?item.donationUserId.substring(0,4):''}}
							<span v-if="item.donationUserId.length>4">...</span>
						</span>
						
						<span class="pricecon" style="color:#E50112;margin-right:0.2rem;">￥{{item.money || ''}}</span>
					</span>
					<span class="datecon">{{item.donationDate || ''}}</span>
				</div>
			</div>
			<div class="l_d">
				<div class="wantbtn" @click="wantbtn">我要捐助</div>
				<div class="checkbtn" @click="checkbtn">捐助查询</div>
			</div>
		</div>
		
	   </div>	
	</div>
	  
	<div class="rotate_indicat">
		<div :class="signindex == index?'indicat_cur':'indicat'" 
		v-for="(item,index) in list" @click="clickChange(index)"></div>
	</div>  
	
	<div class="total_donate">
		<div class="con">
			<div class="name">
				<div class="signle" :style="index != 2?'border-right: 1px solid #FFFFFF;':''"
				v-for="(item,index) in namelist">{{item}}（元）</div>
			</div>
			<div class="price">
				<div class="signle" v-for="(item,index) in namelist">
					<div v-if='index==0' class="f-row-c">
						<!-- {{result.mothMoney||0}} -->
						{{getNum(result.mothMoney||0,0)}}
					</div>
					<div v-if='index==1' class="f-row-c">
						<!-- {{result.yearMoney||0}} -->
						{{getNum(result.yearMoney||0,0)}}
					</div>
					<div v-if='index==2' class="f-row-c">
						<!-- {{result.hisMoney||0,0}} -->
						{{getNum(result.hisMoney||0,0)}}
					</div>
				</div>
			</div>
		</div>  
	</div>
	
	
  </div>
</template>

<script>
import { formatMoney } from '@/utils/util';
export default {
	props:['resultStr'],
	computed:{  
		result:function(){ 
			console.log('resultStr',this.resultStr)
			return this.resultStr?JSON.parse(this.resultStr):{};
		},
	},
  	name: "LandmarkView",
  data() {
    return {
		  curr: 0,
		  list: [],
		  donationList:[],
		  namelist:['本月总额','今年总额','历史总额'],
		//   pricelist:["","",""],
		  
		  signindex:0,
		  timer:null,
		  move:0,
		  countnum:0,
					
		  // moneysum:{},			
		  
    };
  },
  mounted() {
		this.init();
  },
  
  created() {
	  
  },
  updated() {
		
  },
  
  methods: {
	  getNum(val,num){
		  return formatMoney(val,num)
	  },
	// getHomeMoneySum() {
	// 	  var that = this;
	// 	  this.httpGet("/web/statisticsController/getHomeMoneySum").then(res => {
	// 		  	var result=res.result;
	// 			if(result){  
	// 				this.pricelist[0] = formatMoney(result.mothMoney||0,0)
	// 				this.pricelist[1] = formatMoney(result.yearMoney||0,0)
	// 				this.pricelist[2] = formatMoney(result.hisMoney||0,0)
	// 			}
				
	// 	  });
	// },  
	  
	//数字指示器点击事件
	clickChange(index) {
		//参数index为图片索引
		this.signindex = index;
	    this.$refs.img.setActiveItem(index) //调动setActiveItem方法，动态切换图片
	},
	  
	changetab(e){
	  	// console.log(e)
	  	this.signindex = e
	},
	  
    loginSelectOk() {
		this.$emit("swiperFun", {});
    },
    init() {
		this.getDonationList();
		// this.getHomeMoneySum();
      	var that = this;
      	this.httpGet("web/thpWebCarousel/list", { type: 1 }).then(res => {
        	that.list = res.result;
      	});
    },
    nav(link) {
      window.open(link);
    },	
	
	getDonationList() {//web/donation/thpDonationRecord/list
		  var that = this;  	  
		  var pageSize = 15
		  this.httpGet("web/donation/thpDonationRecord/donationTime", {
				pageNo: 1,
				pageSize: pageSize
		  }).then(res => {
				that.donationList = res.result//.records;
				that.countnum = parseInt(that.donationList.length/3)
				if(that.donationList.length%3 != 0){
					that.countnum = that.countnum + 1
				}
				that.timer = setInterval(this.marquee, 3000)
				
		  });
	},
	
	marquee(){
		var num = (this.countnum-1) * 1.8
		// console.log(parseFloat(this.move) + "---" + parseFloat(num))
		if(parseFloat(this.move) >= parseFloat(num)){
			this.move = 0
		}else{
			this.move = this.move + 1.8
		}
		
	},
	 	
	wantbtn(){
		this.$router.push({ path: '/publicwelpro', query: {} });
	},
	
	checkbtn(){
		this.$router.push({ path: '/lovelist_box', query: {} });
	},
	
	//鼠标移入移出
	mouseOver(){
		clearInterval(this.timer);	
	},	  
	mouseLeave(){
		this.timer = setInterval(this.marquee, 3000)
	},
	
	
  }
};
</script>

<style scoped lang="scss">

.landmarkView{
  width: 100%;
  height: 1080px
}

.imgcenter{
	width: 100%;
	cursor: pointer;
}

::-webkit-scrollbar {
	width: 0 !important;
}
::-webkit-scrollbar {
	width: 0 !important;height: 0;
}
		
.realtime_donate{
	position: relative;
	bottom: 650px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	.donatecon{
		width: 18rem;
		display: flex;
		justify-content: flex-end;
	}
	.con{
		width: 400px;
		height: 300px;
		background: #FFFFFF;
		box-shadow: 4px 0px 8px 0px rgba(229, 1, 18, 0.57);
		opacity: 0.85;
		border-radius: 12px;
		z-index: 10;
		.l_a{
			height: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 30px;
			font-weight: 400;
			color: #E50112;
		}
		.l_b{
			height: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			.line{
				width: 66px;
				height: 2px;
				background: #D80C18;
			}
		}
		.l_c{
			min-height: 160px;
			max-height: 160px;
			overflow: hidden;
			.l_con{
				height: 60px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 80px;
				margin-right: 80px;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				.namecon{
					width: 150px;
					display: flex;
					justify-content: space-between;
				}
				.datecon{
					flex: 1;
					text-align: right;
				}
			}
		}
		.l_d{
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: space-around;
			margin-left: 40px;
			margin-right: 40px;
			.wantbtn,
			.checkbtn{
				cursor: pointer;
				width: 120px;
				height: 32px;
				line-height:32px;
				text-align: center;
				background: #29166F;
				border-radius: 15px;
				font-size: 16px;
				font-weight: 400;
				color: #FFFFFF;
			}
			.wantbtn{
				background: #E50112;
			}
		}
		
		
	}
}

.rotate_indicat{
	position: relative;
	bottom: 540px;
	width: 100%;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	.indicat_cur,.indicat{
		cursor: pointer;
		background-color: #D6D6D6;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		margin-right: 20px
	}
	.indicat_cur{background-color: #FFFFFF;}
}

.total_donate{
	position: relative;
	bottom: 521px;
	width: 100%;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	
	.con{
		width: 1200px;
		height: 147px;
		background: #FFFFFF;
		box-shadow: 4px 0px 8px 0px rgba(229, 1, 18, 0.57);
		border-radius: 10px;
		.name,.price{
			width: 1200px;
			display: flex;
			align-items: center;
			font-weight: 400;
			.signle{
				flex: 1;
				text-align: center;
			}
		}
		.name{
			height: 49px;
			background: #F8525E;
			border-radius: 10px 10px 0px 0px;
			font-size: 20px;
			color: #FFFFFF;
		}
		.price{
			height: 98px;
			font-size: 30px;
			color: #E50112;
		}
	}
}


</style>
